import { render, staticRenderFns } from "./PipeStatusPieChart.vue?vue&type=template&id=65aabbd6&scoped=true&"
import script from "./PipeStatusPieChart.vue?vue&type=script&lang=js&"
export * from "./PipeStatusPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aabbd6",
  null
  
)

export default component.exports